// extracted by mini-css-extract-plugin
module.exports = {"message":"Quiz_message__1eiko"};